import React, { FC } from 'react';
import classnames from 'classnames';
import './mobile_bar.scss';

type Props = {
  classNames?: string;
};

export const MobileBar: FC<Props> = ({ children, classNames }) => (
  <div className={classnames('mobile-bar show_on--mobile', classNames)}>
    <div className="mobile-bar__container">{children}</div>
  </div>
);

MobileBar.defaultProps = {
  classNames: '',
};
